var a=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,f=f=>f&&a.test(f)?f:null;export{f as parseConversationId};
//# sourceMappingURL=conversationId.js.map